











import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

/* ===== Gallery Data (Title + Image Mapping) ===== */
const galleryData = [
  { id: 2, imgSrc: "/images/gallery/aura.jpg", title: "Hyundai Aura" },
  { id: 3, imgSrc: "/images/gallery/dzire.jpg", title: "Maruti Suzuki Dzire" },
  { id: 4, imgSrc: "/images/gallery/ertiga.jpg", title: "Maruti Suzuki Ertiga" },
  { id: 5, imgSrc: "/images/gallery/17-seater-tempo-traveller.jpg", title: "17 Seater Tempo Traveller" },
  { id: 6, imgSrc: "/images/gallery/20-seater-tempo-traveller.jpg", title: "20 Seater Tempo Traveller" },
  { id: 7, imgSrc: "/images/gallery/urbania.jpg", title: "Force Urbania" },
  { id: 8, imgSrc: "/images/gallery/32-seater-bus.jpg", title: "32 Seater Bus" },
  { id: 9, imgSrc: "/images/gallery/35-seater-bus.jpg", title: "35 Seater Bus" },
  { id: 10, imgSrc: "/images/gallery/40-seater-bus.jpg", title: "40 Seater Bus" },
  { id: 11, imgSrc: "/images/gallery/45-seater-bus.jpg", title: "45 Seater AC Bus" },
];

/* ===== Booking Component ===== */
export default function Booking({
  cards = [
    {
      title: "Maruti Suzuki Dzire",
      company: "Sanavi Travels",
      priceLabel: "Starting ₹999",
      seater: "4+1",
      desc:
        "The Maruti Suzuki Dzire is a popular compact sedan known for its excellent fuel efficiency, sleek design, and comfortable interiors — ideal for city rides and short outstation trips.",
      image: "/images/gallery/1.jpg",
    },
    {
      title: "Hyundai Aura",
      company: "Sanavi Travels",
      priceLabel: "Starting ₹1,099",
      seater: "4+1",
      desc:
        "The Hyundai Aura is a compact sedan designed for premium comfort and style. With advanced safety features, plush interiors, and smooth performance, it’s perfect for urban and business trips.",
      image: "/images/gallery/3.jpg",
    },
    {
      title: "Maruti Suzuki Ertiga",
      company: "Sanavi Travels",
      priceLabel: "Starting ₹1,499",
      seater: "7+1",
      desc:
        "The Ertiga offers a perfect balance between space and comfort. Its 7-seater layout, stylish design, and efficient performance make it the top choice for family and group travel.",
      image: "/images/gallery/2.jpg",
    },
    {
      title: "17 Seater Tempo Traveller",
      company: "Sanavi Travels",
      priceLabel: "Starting ₹2,499",
      seater: "17+1",
      desc:
        "Ideal for group tours, family functions, and comfortable group travel with ample space.",
      image: "/images/gallery/17-seater-tempo-traveller.jpg",
    },
    {
      title: "20 Seater Tempo Traveller",
      company: "Sanavi Travels",
      priceLabel: "Starting ₹2,799",
      seater: "20+1",
      desc:
        "Spacious seating and comfort for large group tours and outings.",
      image: "/images/gallery/20-seater-tempo-traveller.jpg",
    },
    {
      title: "Force Urbania",
      company: "Sanavi Travels",
      priceLabel: "Starting ₹3,499",
      seater: "12+1",
      desc:
        "A premium tempo traveller offering luxury seating and superior ride comfort.",
      image: "/images/gallery/urbania.jpg",
    },
    {
      title: "32 Seater Bus",
      company: "Sanavi Travels",
      priceLabel: "Starting ₹4,999",
      seater: "32+1",
      desc:
        "Suitable for medium-sized groups, school trips, and corporate travel.",
      image: "/images/gallery/32-seater-bus.jpg",
    },
    {
      title: "35 Seater Bus",
      company: "Sanavi Travels",
      priceLabel: "Starting ₹5,499",
      seater: "35+1",
      desc:
        "Provides ample space and comfort for tours, events, and group transportation.",
      image: "/images/gallery/35-seater-bus.jpg",
    },
    {
      title: "40 Seater Bus",
      company: "Sanavi Travels",
      priceLabel: "Starting ₹5,999",
      seater: "40+1",
      desc:
        "Ideal for large group travel, office outings, and long-distance tours.",
      image: "/images/gallery/40-seater-bus.jpg",
    },
    {
      title: "45 Seater AC Bus",
      company: "Sanavi Travels",
      priceLabel: "Starting ₹6,499",
      seater: "45+1",
      desc:
        "Offers maximum comfort for large groups, pilgrimage trips, and school tours.",
      image: "/images/gallery/45-seater-bus.jpg",
    },
  ],
}) {
  const getGalleryItem = (title) =>
    galleryData.find(
      (item) => item.title.toLowerCase() === title.toLowerCase()
    );

  const handleWhatsAppBooking = (title) => {
    const phone = "917387507373";
    const message = `Hello Sanavi Travels, I want to book ${title}. Please share more details.`;
    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <>
      {/* ===== Page Header ===== */}
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white">
                  Booking
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== Booking Cards ===== */}
      <section
        className="taxi-rates-page section-space"
        style={{ backgroundColor: "#f9fafc", padding: "80px 0" }}
      >
        <div className="container">
          <div className="row g-4 justify-content-center">
            {cards.map((c, idx) => {
              const galleryItem = getGalleryItem(c.title);

              return (
                <div className="col-xl-4 col-md-6 d-flex" key={idx}>
                  <div className="taxi-card d-flex flex-column w-100">
                    {/* Image */}
                    <div style={{ background: "#F26722", padding: 20 }}>
                      <img
                        src={galleryItem?.imgSrc || c.image}
                        alt={c.title}
                        style={{
                          width: "100%",
                          maxHeight: 220,
                          objectFit: "contain",
                        }}
                      />
                    </div>

                    {/* Content */}
                    <div
                      style={{
                        background: "#000",
                        color: "#fff",
                        padding: 25,
                        flex: 1,
                      }}
                      className="d-flex flex-column justify-content-between"
                    >
                      <div>
                        <h3 className="text-center">{c.title}</h3>
                        {/* <p className="text-center text-muted">{c.company}</p> */}
                        {/* <p className="text-center">{c.desc}</p> */}
                        <p className="text-center fw-bold">Seater: {c.seater}</p>
                        {/* <p className="text-center text-success fw-bold">{c.priceLabel}</p> */}
                      </div>

                      <button
                        onClick={() => handleWhatsAppBooking(c.title)}
                        className="btn btn-success mt-3"
                      >
                        <i className="fab fa-whatsapp" /> Book Now
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
